import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import * as $ from "react";
import { forwardRef as K, useRef as Q, useImperativeHandle as X, useMemo as T } from "react";
import { _ as G } from "./composeRefs-YONvD-rx.mjs";
import { l as E } from "./lodash-5ofSKtz3.mjs";
import { F as lo } from "./field-context-CFgvjLYL.mjs";
import { G as uo } from "./group-legend-1Z-tEAIm.mjs";
import { S as po } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { S as fo } from "./status-message-BMoS1d1Y.mjs";
import { F as mo } from "./form-note-CbSVsgBQ.mjs";
import { f as c } from "./index-LyFokDcn.mjs";
import { c as w, b as V, m as bo } from "./tss-DN0acMKN.mjs";
import { M as H, d as q } from "./constants-CnFYFetN.mjs";
import { S as xo, F as go } from "./FormControlLabel-BtrCkdi3.mjs";
import { g as Y, c as oo } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { c as eo } from "./createSvgIcon-ButWPptu.mjs";
import { s as M, b as ro, u as ho, c as ao } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { m as to } from "./memoTheme-BzXKG_-k.mjs";
import { u as Ro } from "./useFormControl-C9UMlaFq.mjs";
import { g as no } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { c as A } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { F as Co } from "./FormControl-C7vROVtA.mjs";
import { u as yo } from "./useControlled-ZIJRsfP8.mjs";
import { u as So } from "./useForkRef-C_4o__cU.mjs";
import { u as vo } from "./useId-CK6Kn3Tn.mjs";
import { F as Fo } from "./FormGroup-JbpzXay2.mjs";
import { g as ko } from "./get-aria-describedby-G1wcWKF2.mjs";
function $o(...o) {
  return o.reduce((e, a) => a == null ? e : function(...s) {
    e.apply(this, s), a.apply(this, s);
  }, () => {
  });
}
const jo = eo(/* @__PURE__ */ t.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), Io = eo(/* @__PURE__ */ t.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), wo = M("span", {
  shouldForwardProp: ro
})({
  position: "relative",
  display: "flex"
}), Mo = M(jo)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Po = M(Io)(to(({
  theme: o
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: o.transitions.create("transform", {
    easing: o.transitions.easing.easeIn,
    duration: o.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: o.transitions.create("transform", {
        easing: o.transitions.easing.easeOut,
        duration: o.transitions.duration.shortest
      })
    }
  }]
})));
function so(o) {
  const {
    checked: e = !1,
    classes: a = {},
    fontSize: r
  } = o, s = {
    ...o,
    checked: e
  };
  return /* @__PURE__ */ t.jsxs(wo, {
    className: a.root,
    ownerState: s,
    children: [/* @__PURE__ */ t.jsx(Mo, {
      fontSize: r,
      className: a.background,
      ownerState: s
    }), /* @__PURE__ */ t.jsx(Po, {
      fontSize: r,
      className: a.dot,
      ownerState: s
    })]
  });
}
const io = /* @__PURE__ */ $.createContext(void 0);
function No() {
  return $.useContext(io);
}
function Bo(o) {
  return Y("MuiRadio", o);
}
const W = no("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), zo = (o) => {
  const {
    classes: e,
    color: a,
    size: r
  } = o, s = {
    root: ["root", `color${w(a)}`, r !== "medium" && `size${w(r)}`]
  };
  return {
    ...e,
    ...ao(s, Bo, e)
  };
}, Go = M(xo, {
  shouldForwardProp: (o) => ro(o) || o === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (o, e) => {
    const {
      ownerState: a
    } = o;
    return [e.root, a.size !== "medium" && e[`size${w(a.size)}`], e[`color${w(a.color)}`]];
  }
})(to(({
  theme: o
}) => ({
  color: (o.vars || o).palette.text.secondary,
  [`&.${W.disabled}`]: {
    color: (o.vars || o).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: o.vars ? `rgba(${o.vars.palette.action.activeChannel} / ${o.vars.palette.action.hoverOpacity})` : V(o.palette.action.active, o.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(o.palette).filter(A()).map(([e]) => ({
    props: {
      color: e,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: o.vars ? `rgba(${o.vars.palette[e].mainChannel} / ${o.vars.palette.action.hoverOpacity})` : V(o.palette[e].main, o.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(o.palette).filter(A()).map(([e]) => ({
    props: {
      color: e,
      disabled: !1
    },
    style: {
      [`&.${W.checked}`]: {
        color: (o.vars || o).palette[e].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function Oo(o, e) {
  return typeof e == "object" && e !== null ? o === e : String(o) === String(e);
}
const _ = /* @__PURE__ */ t.jsx(so, {
  checked: !0
}), Z = /* @__PURE__ */ t.jsx(so, {}), J = /* @__PURE__ */ $.forwardRef(function(e, a) {
  const r = ho({
    props: e,
    name: "MuiRadio"
  }), {
    checked: s,
    checkedIcon: l = _,
    color: x = "primary",
    icon: v = Z,
    name: h,
    onChange: d,
    size: p = "medium",
    className: n,
    disabled: R,
    disableRipple: C = !1,
    ...b
  } = r, y = Ro();
  let f = R;
  y && typeof f > "u" && (f = y.disabled), f ?? (f = !1);
  const u = {
    ...r,
    disabled: f,
    disableRipple: C,
    color: x,
    size: p
  }, i = zo(u), m = No();
  let F = s;
  const k = $o(d, m && m.onChange);
  let S = h;
  return m && (typeof F > "u" && (F = Oo(m.value, r.value)), typeof S > "u" && (S = m.name)), /* @__PURE__ */ t.jsx(Go, {
    type: "radio",
    icon: /* @__PURE__ */ $.cloneElement(v, {
      fontSize: Z.props.fontSize ?? p
    }),
    checkedIcon: /* @__PURE__ */ $.cloneElement(l, {
      fontSize: _.props.fontSize ?? p
    }),
    disabled: f,
    ownerState: u,
    classes: i,
    name: S,
    checked: F,
    onChange: k,
    ref: a,
    className: oo(i.root, n),
    ...b
  });
});
function Do(o) {
  return Y("MuiRadioGroup", o);
}
no("MuiRadioGroup", ["root", "row", "error"]);
const Uo = (o) => {
  const {
    classes: e,
    row: a,
    error: r
  } = o;
  return ao({
    root: ["root", a && "row", r && "error"]
  }, Do, e);
}, Lo = /* @__PURE__ */ $.forwardRef(function(e, a) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    children: s,
    className: l,
    defaultValue: x,
    name: v,
    onChange: h,
    value: d,
    ...p
  } = e, n = $.useRef(null), R = Uo(e), [C, b] = yo({
    controlled: d,
    default: x,
    name: "RadioGroup"
  });
  $.useImperativeHandle(r, () => ({
    focus: () => {
      let i = n.current.querySelector("input:not(:disabled):checked");
      i || (i = n.current.querySelector("input:not(:disabled)")), i && i.focus();
    }
  }), []);
  const y = So(a, n), f = vo(v), u = $.useMemo(() => ({
    name: f,
    onChange(i) {
      b(i.target.value), h && h(i, i.target.value);
    },
    value: C
  }), [f, h, b, C]);
  return /* @__PURE__ */ t.jsx(io.Provider, {
    value: u,
    children: /* @__PURE__ */ t.jsx(Fo, {
      role: "radiogroup",
      ref: y,
      className: oo(R.root, l),
      ...p,
      children: s
    })
  });
});
function To(o = "", e = "") {
  if (o) {
    const a = `${o}-radio-group`, r = e ? `-${e}` : "";
    return `${a}${r}`;
  }
}
function Eo(o = "", e = "", a) {
  if (o) {
    const r = `${o}-radio`, s = e ? `-${e}` : "", l = `-${a}`;
    return `${r}${s}${l}`;
  }
}
const Vo = 200, Ho = bo({ name: "Radio" })(({ constructs: o, mixins: e, mode: a, palette: r, transitions: s, typography: l }, { checked: x, label: v, note: h, size: d }, p) => {
  const n = !!v, R = !!h, C = c.ifFeature("encore", 0, d === "small" ? "0" : "2px"), b = { easing: "ease", duration: Vo };
  return {
    root: {
      marginBottom: c.ifFeature("encore", R ? "2px" : "12px", R ? "1px" : "6px"),
      outline: a === H.Dye ? `1px solid ${q.main}` : void 0
    },
    labelRoot: {
      marginLeft: 0,
      marginRight: 0,
      "& > .MuiButtonBase-root:hover": {
        backgroundColor: c.ifFeature("encore", "unset")
      }
    },
    label: {
      color: x ? r.grey[1e3] : r.grey[800],
      fontSize: l.body1.fontSize,
      // 15px
      fontWeight: x ? 600 : l.fontWeightRegular,
      lineHeight: "1.466rem",
      // 22px
      marginLeft: "8px",
      "&.MuiFormControlLabel-label.Mui-disabled": {
        color: c.ifFeature("encore", r.gray[600])
      }
    },
    note: {
      color: c.ifFeature("encore", r.gray[600]),
      margin: c.ifFeature("encore", "1px 0 4px 28px", "1px 0 4px 24px")
    },
    small: {
      "& .MuiFormControlLabel-label": {
        fontSize: l.fabricFontSize("small"),
        lineHeight: c.ifFeature("encore", l.small.lineHeight, "1.1333rem")
        // 17px
      }
    },
    radioRoot: {
      display: "inline-flex",
      marginTop: n ? C : 0,
      padding: c.ifFeature("encore", 0),
      alignSelf: c.ifFeature("encore", "start"),
      position: c.ifFeature("encore", "relative"),
      top: c.ifFeature("encore", d === "medium" ? "1px" : "2px")
    },
    radioIcon: {
      backgroundColor: c.ifFeature("encore", r.gray[100]),
      border: c.ifFeature("encore", e.border(1, r.gray[400]), e.border(1, r.grey[500])),
      borderRadius: "50%",
      boxShadow: c.ifFeature(
        "encore",
        `inset 1px 1px 0 0 ${e.alpha(o.surface.neutral.xxStrong, 0.05)}`,
        `inset 0px 2px 2px rgba(0, 0, 0, 0.15), 0px 0px 0px 0px ${e.alpha(r.primary.lighter, 0.35)}`
      ),
      width: c.ifFeature("encore", d === "small" ? "16px" : "20px", d === "small" ? "14px" : "16px"),
      height: c.ifFeature("encore", d === "small" ? "16px" : "20px", d === "small" ? "14px" : "16px"),
      position: "relative",
      transition: s.create("box-shadow", b),
      "&, &:before, &:after": {
        boxSizing: "border-box"
      },
      "&:before, &:after": {
        content: '""',
        display: "block",
        borderRadius: "50%",
        width: "calc(100% + 2px)",
        height: "calc(100% + 2px)",
        position: "absolute",
        top: "-1px",
        left: "-1px",
        transform: "scale(0)",
        transition: s.create("transform", b)
      },
      "&:before": {
        backgroundColor: a === H.Dye ? q.main : r.primary.main,
        transformOrigin: "50% 50%"
      },
      "&:after": {
        border: c.ifFeature(
          "encore",
          d === "small" ? e.border(4, "transparent") : e.border(5, "transparent"),
          e.border(4, "transparent")
        ),
        backgroundClip: "padding-box",
        backgroundColor: r.common.white,
        borderRadius: "50%",
        transitionDelay: "-1s"
      },
      [`.${p.root}.Mui-checked &, .${p.root} input:checked + &`]: {
        boxShadow: c.ifFeature("encore", `1px 1px 0 0 ${e.alpha(o.surface.neutral.xxStrong, 0.06)}`)
      },
      [`.${p.root}.Mui-focusVisible &, .${p.root} input:focus + &`]: {
        boxShadow: c.ifFeature(
          "encore",
          `0 0 0 3px ${e.alpha(o.surface.primary.weak, 1)}`,
          `inset 0px 0px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 2px ${e.alpha(r.primary.lighter, 0.35)}`
        ),
        transitionDelay: "100ms"
      },
      "input:disabled ~ &": {
        boxShadow: "none",
        border: c.ifFeature("encore", e.border(1, r.grey[200]), e.border(1, r.grey[400]))
      }
    },
    radioCheckedIcon: {
      "&:before, &:after": {
        transform: "scale(1)"
      },
      "input:disabled ~ &:before": {
        backgroundColor: r.grey[400]
      }
    }
  };
}), qo = K(
  ({
    apiRef: o,
    ariaDescribedby: e,
    biId: a,
    checked: r,
    className: s,
    classes: l = {},
    disabled: x,
    id: v,
    inputProps: h,
    label: d,
    name: p,
    note: n,
    onChange: R,
    required: C,
    size: b = "medium",
    value: y
  }, f) => {
    const { classes: u, cx: i } = Ho({ checked: r, label: d, note: n, size: b }), m = (S) => {
      R({ value: y }, S);
    }, F = Q(null);
    X(
      o,
      () => ({
        focus: () => {
          var S;
          (S = F.current) == null || S.focus();
        }
      }),
      [F]
    );
    const k = {
      checked: r,
      checkedIcon: /* @__PURE__ */ t.jsx("span", { className: i(u.radioIcon, u.radioCheckedIcon) }),
      icon: /* @__PURE__ */ t.jsx("span", { className: u.radioIcon }),
      id: v,
      inputProps: {
        "aria-describedby": e,
        "aria-label": d ? void 0 : "radio button",
        "data-bi-id": Eo(a, p, y),
        ...h
      },
      name: p,
      onChange: m,
      required: C,
      size: b,
      value: y
    };
    return d ? /* @__PURE__ */ t.jsxs("span", { "aria-disabled": x, className: i(u.root, l.root), "data-fabric-component": "Radio", children: [
      /* @__PURE__ */ t.jsx(
        go,
        {
          classes: {
            root: i(u.labelRoot, l.labelRoot),
            label: i(u.label, l.label)
          },
          className: i(s, {
            [u.small]: b === "small"
          }),
          control: /* @__PURE__ */ t.jsx(J, { classes: { root: i(u.radioRoot, l.radio) }, ...k }),
          disabled: x,
          inputRef: G(f, F),
          label: d,
          value: y
        }
      ),
      n && /* @__PURE__ */ t.jsx("div", { className: u.note, children: /* @__PURE__ */ t.jsx(mo, { children: n }) })
    ] }) : /* @__PURE__ */ t.jsx(
      J,
      {
        classes: { root: i(u.radioRoot, l.radio) },
        className: s,
        disabled: x,
        inputRef: G(f, F),
        ...k,
        "data-fabric-component": "Radio"
      }
    );
  }
), ge = K(
  ({
    apiRef: o,
    ariaDescribedby: e,
    ariaLabel: a,
    biId: r,
    className: s,
    classes: l = {},
    containerRef: x,
    disabled: v = !1,
    errorMessage: h,
    fullWidth: d,
    id: p,
    items: n,
    label: R,
    name: C,
    onBlur: b,
    onChange: y,
    required: f = !1,
    note: u,
    size: i = "medium",
    status: m = "default",
    warningMessage: F,
    value: k
  }, S) => {
    const O = T(() => p || E.uniqueId("radio-group-"), [p]), co = `${O}-note`, D = `${O}-legend`, U = T(() => E.uniqueId("status-message"), []), P = m === "error" ? h : F, N = Q(/* @__PURE__ */ new WeakMap());
    return X(
      o,
      () => ({
        focus: () => {
          var L;
          const g = n == null ? void 0 : n.findIndex((j) => j.value === k), B = n == null ? void 0 : n.findIndex((j) => !j.disabled), I = g !== -1 ? g : B, z = n == null ? void 0 : n[I];
          if (I !== -1 && n) {
            const j = (L = N.current) == null ? void 0 : L.get(z);
            j && j.focus();
          }
        }
      }),
      [n, k]
    ), /* @__PURE__ */ t.jsxs(
      Co,
      {
        "aria-invalid": m === "error",
        "aria-required": f,
        classes: { root: l.root },
        className: s,
        component: "fieldset",
        "data-fabric-component": "RadioGroup",
        disabled: v,
        fullWidth: d,
        onBlur: b,
        ref: G(S, x),
        required: f,
        role: "radiogroup",
        children: [
          R ? /* @__PURE__ */ t.jsx(lo.Provider, { value: { status: m, required: f, disabled: v, noteId: co }, children: /* @__PURE__ */ t.jsx(uo, { id: D, label: R, note: u }) }) : /* @__PURE__ */ t.jsx("legend", { id: D, children: /* @__PURE__ */ t.jsx(po, { children: a }) }),
          /* @__PURE__ */ t.jsx("div", { "data-bi-id": To(r, C), children: /* @__PURE__ */ t.jsx(Lo, { name: C, ref: S, value: k, children: n.map((g, B) => {
            const I = g.id || `${g.value}-${B}`;
            return /* @__PURE__ */ t.jsx(
              qo,
              {
                apiRef: (z) => {
                  N.current && N.current.set(g, z);
                },
                ariaDescribedby: ko(P ? U : "", e),
                checked: g.value === k,
                disabled: g.disabled,
                id: g.id,
                label: g.label,
                note: g.note,
                onChange: y,
                size: i,
                value: g.value
              },
              I
            );
          }) }) }),
          P && (m === "error" || m === "warning") && /* @__PURE__ */ t.jsx(fo, { id: U, message: P, status: m })
        ]
      }
    );
  }
);
export {
  ge as R,
  qo as a
};
//# sourceMappingURL=radio-group-t8rlN9cR.mjs.map
